<template>
  <div :key="componentKey">
    <IstInfoCenter
      v-morph:InfocenterDrawer:boxes:200.resize="morphInfocenter"
      :newsItems="newsItems"
      v-on:close="morphInfocenter = 'InfocenterBtn'"
    >
    </IstInfoCenter>
    <q-layout class="ist-root" view="hHh lpR fFf">
      <input type="checkbox" id="istmenutoggle" />
      <IstLayoutLeftMenu
        id="page_navigation"
        :menu="menuEntries"
        app-name="Dagtilbud Personale"
        :urlpath="urlpath"
        :buildversion="buildversion"
      ></IstLayoutLeftMenu>

      <main class="ist-main">
        <header>
          <div class="ist-header-section">
            <div class="ist-header-section-start">
              <div class="row">
                <!-- v-bind:style makes space for breadcrumbs. -->
                <h3
                  class="ist-header-title"
                  v-bind:style="{
                    'line-height': titleWithCrumbs ? 'initial !important' : ''
                  }"
                >
                  {{ title }}
                </h3>

                <!-- CRUMB START -->
              </div>
              <div class="row" v-if="titleWithCrumbs && user && user.isManager()">
                <q-breadcrumbs>
                  <q-breadcrumbs-el
                    :to="bc.route"
                    v-for="bc in titleWithCrumbs.breadCrumbs"
                    :key="bc.title"
                    v-bind:class="{ clickable: bc.route.length > 0 || bc.breadCrumbs.length > 0 }"
                  >
                    {{ bc.title }}
                    <i
                      aria-hidden="true"
                      v-if="bc.breadCrumbs.length > 0"
                      role="presentation"
                      class="q-icon notranslate mdi mdi-chevron-down"
                    ></i>
                    <q-menu v-if="bc.breadCrumbs.length > 0">
                      <q-list dense style="min-width: 100px">
                        <q-item
                          v-for="bcchild in bc.breadCrumbs"
                          v-bind:key="bcchild.title"
                          clickable
                          v-close-popup
                        >
                          <q-item-section class="clickable" @click="goToRoute(bcchild.route)">{{
                            bcchild.title
                          }}</q-item-section>
                        </q-item>
                      </q-list>
                    </q-menu>
                  </q-breadcrumbs-el>
                </q-breadcrumbs>
                <!-- CRUMB END -->
              </div>
            </div>
            <div class="ist-header-section-end--shrink">
              <div class="ist-header-toolbar">
                <!--        <q-btn
                  v-if="user && user.isManager()"
                  class="ist-header-toolbar--item"
                  round
                  flat
                  unelevated
                  icon="mdi-account-off"
                  @click="goToAbsenceRequests()"
                  :title="$t('absenceRequest.absenceRequests')"
                >
                  <q-badge
                    style="top: 12px"
                    color="red"
                    floating
                    v-if="numberOfPendingAbsenceRequests > 0"
                    >{{ numberOfPendingAbsenceRequests }}</q-badge
                  >
                </q-btn> -->
                <q-btn
                  v-if="user && user.isManager()"
                  class="ist-header-toolbar--item"
                  round
                  flat
                  unelevated
                  icon="mdi-bell"
                  :title="$t('infocenter.messages')"
                  @click="morphInfocenter = 'InfocenterDrawer'"
                  v-morph:InfocenterBtn:boxes:200.resize="morphInfocenter"
                >
                  <q-badge
                    style="top: 12px"
                    color="red"
                    floating
                    v-if="numberOfUnreadMessages > 0"
                    >{{ numberOfUnreadMessages }}</q-badge
                  >
                </q-btn>
                <q-btn-dropdown
                  unelevated
                  flat
                  id="user-institution"
                  class="ist-header-toolbar--item desktop-only"
                >
                  <template v-slot:label>
                    <div id="menuinstitutionname">
                      {{ institutionsNavn }}
                      <br />
                      <div style="text-align: end">{{ code }}</div>
                    </div>
                  </template>

                  <q-list separator v-if="user">
                    <q-item
                      v-bind:key="inst.id"
                      v-for="inst in user.selectable_institutions"
                      clickable
                      v-on:click="changeInstitution(inst)"
                    >
                      <q-item-section :id="'code' + inst.code"
                        >{{ inst.name }} <br />
                        <div>{{ inst.code }}</div></q-item-section
                      >
                    </q-item>
                  </q-list>
                </q-btn-dropdown>
                <q-btn-dropdown unelevated flat id="user-profile" class="ist-header-toolbar--item">
                  <template v-slot:label>
                    <ISTAvatar
                      v-if="user && user.isEmployee() && username !== ''"
                      :fullname="username"
                    ></ISTAvatar>
                    <q-avatar
                      v-if="user && user.isManager()"
                      size="32px"
                      color="primary"
                      text-color="white"
                      >{{ shortname }}</q-avatar
                    >
                    <div id="menuusername">{{ username }}</div>
                  </template>

                  <q-list separator>
                    <q-item id="institutionsNavn" class="mobile-only">
                      <q-btn-dropdown
                        v-if="user && user.selectable_institutions.length > 1"
                        unelevated
                        flat
                        id="user-institution"
                        class="ist-header-toolbar--item"
                      >
                        <template v-slot:label>
                          <div id="menuinstitutionname">{{ institutionsNavn }}</div>
                        </template>

                        <q-list separator>
                          <q-item
                            v-bind:key="inst.id"
                            v-for="inst in user.selectable_institutions"
                            clickable
                            v-on:click="changeInstitution(inst)"
                          >
                            <q-item-section>{{ inst.name }}</q-item-section>
                          </q-item>
                        </q-list>
                      </q-btn-dropdown>
                      <q-item-section v-if="user && user.selectable_institutions.length === 1">{{
                        institutionsNavn
                      }}</q-item-section>
                    </q-item>
                    <q-item clickable v-on:click="visBrugerProfil" id="vis-brugerprofil">
                      <q-item-section>{{ $t("layout.UserProfile") }}</q-item-section>
                    </q-item>
                    <q-item
                      v-if="loginTypeUserNamePassword"
                      clickable
                      v-on:click="visChangePassword"
                      id="vis-changePassword"
                    >
                      <q-item-section>{{ $t("changePassword.changePassword1") }}</q-item-section>
                    </q-item>
                    <q-item
                      clickable
                      v-on:click="visChangeToUnilogin"
                      v-if="loginTypeUserNamePassword"
                      id="vis-changeToUnilogin"
                    >
                      <q-item-section>{{ $t("changeToUnilogin") }}</q-item-section>
                    </q-item>
                    <q-item clickable v-on:click="visSupport" id="vis-support">
                      <q-item-section>{{ $t("layout.support") }}</q-item-section>
                    </q-item>

                    <q-item v-if="devEnv" clickable>
                      <q-item-section>{{ $t("layout.sprog") }}</q-item-section>
                      <q-item-section side>
                        <q-icon name="keyboard_arrow_left" />
                      </q-item-section>

                      <q-menu anchor="top right" self="top left">
                        <q-list>
                          <q-item clickable v-on:click="skiftsprog('en')" id="english">
                            <q-item-section>{{ $t("layout.engelsk") }}</q-item-section>
                          </q-item>
                          <q-item clickable v-on:click="skiftsprog('da')" id="dansk">
                            <q-item-section>{{ $t("layout.dansk") }}</q-item-section>
                          </q-item>
                        </q-list>
                      </q-menu>
                    </q-item>
                    <q-item clickable v-on:click="goToLogout" id="logout">
                      <q-item-section>{{ $t("layout.Logout") }}</q-item-section>
                    </q-item>
                  </q-list>
                </q-btn-dropdown>
              </div>
            </div>
          </div>
        </header>
        <div class="ist-contents">
          <div
            class="ist-contents--overlay"
            v-show="morphInfocenter != 'InfocenterBtn'"
            @click="morphInfocenter = 'InfocenterBtn'"
          ></div>
          <router-view :key="$route.fullPath" />
        </div>
      </main>
    </q-layout>
  </div>
</template>
<script lang="ts">
import * as Sentry from "@sentry/browser";
import { Options, Vue, Watch } from "vue-property-decorator";
import { EventBus, eEventBus } from "./../eventbus";
import { Dialog, useQuasar } from "quasar";
import { User, eLoginType } from "../modules/security/models/user-model";
import { eSalerySystem, Institution } from "../models/institution-model";
import IstLayoutLeftMenu, { menutype } from "../components/IstLayoutLeftMenu.vue";
import IstInfoCenter from "../components/IstInfoCenter.vue";
import IstFormInput from "../components/IstFormInput.vue";
import store from "../store";
import {
  ShowChangePasswordDialog,
  ShowUserProfileDialog,
  ChangeToUniLoginDialog
} from "../components/dialogs";
import { Title } from "../models/title";
import { INewstype } from "../components/IstInfoCenter";
import { useRoute, useRouter } from "vue-router";
import i18n from "@/i18n";
import {
  addMonths,
  addYears,
  differenceInDays,
  endOfMonth,
  format,
  startOfMonth,
  subMonths
} from "date-fns";
import { loginService } from "@/modules/security/service/login.service";
import filters from "@/components/filters/Filters";
import { Employee } from "@/models/employees";
import { SalaryRecord } from "@/models/salaryRecord";
import { WebAcceptPages } from "@/models/webacceptpages-model";
import { approveWorkHoursService } from "@/services/approveworkhours.service";
import { Absence } from "@/models/absences";
import { AbsenceRequest } from "@/models/absenceRequest-model";

@Options({
  components: {
    IstLayoutLeftMenu,
    IstInfoCenter
  }
})
export default class IDA extends Vue {
  router = useRouter();
  q = useQuasar();
  devEnv: boolean = import.meta.env.NODE_ENV === "development";
  title = "";
  urlpath = "";
  username = "";
  institutionsNavn = "";
  code = "";
  buildversion = "Development";
  showInfocenter = true;
  showContentsOverlay = true;
  morphInfocenter = "InfocenterBtn";
  component: any = IstFormInput;
  institutionValg: {
    label: string;
    value: number;
    institutionsKode: number | null;
    selected: boolean;
  }[] = [];
  menuEntries: menutype[] = [];
  newsItems: INewstype[] = [];
  shortname = "";
  selectedInstitutionId = -1;
  numberOfUnreadMessages: number = 0;
  numberOfPendingAbsenceRequests: number = 0;
  user: User = store.getters["security/getUser"]();
  componentKey = 0;
  loginTypeUserNamePassword = false;
  showSalaryWarningIcon = false;
  showAbsenceWarningIcon = false;
  showChangeRequestIcon = false;
  intervalId: number | null = null;
  readonly LAST_SELECTED_INSTITUTION_KEY = "lastSelectedInstitution";

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(newVal: any) {
    this.onUrlPath(newVal.path);
  }

  @Watch("showChangeRequestIcon")
  onShowChangeRequestIconChange() {
    this.setMenu();
  }

  @Watch("showSalaryWarningIcon")
  onShowSalaryWarningIconChange() {
    this.setMenu();
  }

  @Watch("showAbsenceWarningIcon")
  onShowAbsenceWarningIconChange() {
    this.setMenu();
  }

  async created() {
    if (localStorage.testToken) {
      let token = localStorage.testToken;
      let user = await loginService.LoginOpenId(token);
      store.commit("security/setUser", user);
      store.commit("security/setToken", token);
      localStorage.removeItem("testToken");
      this.router.push({ path: "/module/dashboard" });
    }
    this.user = await store.dispatch("security/getUser");
    if (this.user.errors !== "") {
      this.showFkaErrors(this.user.errors);
    }
    this.loginTypeUserNamePassword =
      this.user && this.user.login_type === eLoginType.USERNAME_PASSWORD && this.user.isManager();

    // Check for last selected institution
    const lastSelectedInstitution = localStorage.getItem(
      this.LAST_SELECTED_INSTITUTION_KEY + this.user.id
    );
    if (lastSelectedInstitution && this.user && this.user.selectable_institutions) {
      const savedInstitution = this.user.selectable_institutions.find(
        (inst) => inst.id.toString() === lastSelectedInstitution
      );
      if (savedInstitution && savedInstitution.code !== this.user.selected_institution?.code) {
        await this.changeInstitution(savedInstitution);
        return;
      }
    }

    this.institutionsNavn = this.user?.selected_institution
      ? this.user.selected_institution?.name
      : "?";
    this.code = this.user?.selected_institution
      ? this.user.selected_institution?.code.toString()
      : "";
    this.setMenu();
    window.addEventListener("scroll", () => {
      document.documentElement.style.setProperty("--scroll-y", `${window.scrollY}px`);
    });
  }

  showFkaErrors(errors: string) {
    Dialog.create({
      title: "Fejl ved FKA login",
      message:
        "Det var ikke muligt at give adgang til alle institutioner på medsendte skolekoder/gnumre.<br><br>" +
        errors,
      color: "primary",
      html: true
    });
  }

  goToRoute(route) {
    this.router.push(route);
  }

  titleWithCrumbs: Title | null = null;

  setup() {
    if (this.router && useRoute().meta) {
      const s: string | undefined = useRoute().meta.title;
      this.onReload(s || "");
    }
  }

  beforeUnmount() {
    this.clearInterval();
  }

  async mounted() {
    window.idaStore = store;
    const currentYear = new Date().getFullYear();
    await store.dispatch("holidays/fetchHolidays", currentYear - 1);
    await store.dispatch("holidays/fetchHolidays", currentYear);
    await store.dispatch("holidays/fetchHolidays", currentYear + 1);

    if (import.meta.env.VITE_VUE_APP_COMMITHASH) {
      this.buildversion = import.meta.env.VITE_VUE_APP_COMMITHASH.substring(0, 4).concat(
        "...",
        import.meta.env.VITE_VUE_APP_COMMITHASH.substr(
          import.meta.env.VITE_VUE_APP_COMMITHASH.length - 4
        )
      );
    }

    const t = this;

    EventBus.on(eEventBus.changetitle, (NewTitle) => {
      this.titleWithCrumbs = null;
      if (NewTitle instanceof Title) {
        this.titleWithCrumbs = NewTitle;
        t.onReload(NewTitle.title);
        return;
      }
      t.onReload(NewTitle);
    });
    EventBus.on(eEventBus.changeurlpath, (NewUrlpath) => {
      t.onUrlPath(NewUrlpath);
    });
    EventBus.on(eEventBus.NonBreakingDataError, (error) => {
      if (error.text.length > 0) {
        this.q.notify({
          // only required parameter is the message:
          message: error.text,
          timeout: 3000,
          color: "warning"
        });
      }
      Sentry.withScope((scope) => {
        scope.setExtra("nonErrorException", true);
        Sentry.captureException(error.error);
      });
      if (!store.state.mainConfig.ENVIRONMENTNAME) {
        // eslint-disable-next-line
        console.log("NonBreakingDataError", error);
      }
    });

    EventBus.on("showSalaryWarningIcon", (showWarningIcon: boolean) => {
      this.showSalaryWarningIcon = showWarningIcon;
    });

    EventBus.on("showChangeRequestWarningIcon", (showWarningIcon: boolean) => {
      this.showChangeRequestIcon = showWarningIcon;
    });

    EventBus.on("showAbsenceWarningIcon", (showWarningIcon: boolean) => {
      this.showAbsenceWarningIcon = showWarningIcon;
    });

    EventBus.on("numberOfPendingAbsenceRequests", (numberOfPendingAbsenceRequests: number) => {
      this.numberOfPendingAbsenceRequests = numberOfPendingAbsenceRequests;
    });

    EventBus.on(eEventBus.BreakingDataError, (error: { text: string; error: any }) => {
      let errorMessage = "";
      if (error.error.response) {
        error.error.response.data.errors.forEach((e) => {
          errorMessage += e.message + "\n";
        });
      }

      if (error.text.length > 0) {
        this.q.notify({
          // only required parameter is the message:
          caption: errorMessage,
          message: error.text,
          timeout: 3000,
          color: "negative"
        });
      }
      Sentry.withScope((scope) => {
        scope.setExtra("nonErrorException", true);
        Sentry.captureException(error.error);
      });
      if (!store.state.mainConfig.ENVIRONMENTNAME) {
        // eslint-disable-next-line
        console.log("BreakingDataError", error);
      }
    });
    EventBus.on(eEventBus.InformationDataDone, (Information: string) => {
      this.q.notify({
        // only required parameter is the message:
        message: Information,
        timeout: 2000,
        color: "positive",
        badgeStyle: "opacity: 0"
      });
    });

    store.watch(
      store.getters["security/getUser"],
      async (n) => {
        this.user = n as User;
        this.handlePasswordExpiration();

        this.selectedInstitutionId = this.user.selected_institution
          ? this.user.selected_institution.id
          : -1;

        if (this.user.selected_institution) {
          this.institutionsNavn = this.user.selected_institution.name;
          this.code = this.user.selected_institution.code.toString();
          this.setUserName();
          if (this.user.isManager()) {
            this.showSalaryWarningIcon = await this.anyFailedKmdRecords("salary");
            this.showAbsenceWarningIcon = await this.anyFailedKmdRecords("absence");
            // SFOP-6844
            // this.numberOfPendingAbsenceRequests = await this.pendingAbsenceRequests();
            this.startInterval();
          }
        }
      },
      { immediate: true, deep: false }
    );

    store.watch(
      store.getters["institutions/institutions"],
      (n) => {
        let Institutions = n as Institution[];
        this.institutionValg = [];
        for (let index = 0; index < Institutions.length; index++) {
          const institution = Institutions[index];
          this.institutionValg.push({
            label: institution.name,
            value: institution.id,
            institutionsKode: institution.code,
            selected: this.selectedInstitutionId === institution.id
          });
          if (this.selectedInstitutionId === institution.id) {
            this.institutionsNavn = institution.name;
            this.code = institution.code ? institution.code.toString() : "";
          }
        }
      },
      { immediate: true, deep: false }
    );

    store.watch(store.getters["security/getSelectedInstitution"], (n: Institution) => {
      this.institutionsNavn = n.name;
    });

    store.watch(
      store.getters["infoCenter/getInfoCenterItems"],
      (news: INewstype[]) => {
        this.numberOfUnreadMessages = news.filter((obj) => obj.unread).length;
        this.newsItems.length = 0;
        this.newsItems.push(...news);
      },
      { immediate: true, deep: true }
    );
    if (!this.user.employee_id) {
      store.dispatch("infoCenter/fetchInfoCenter").then();
    }
  }

  async goToAbsenceRequests() {
    this.router.push({ path: "/module/absence", query: { tab: "approve" } });
  }

  async setUserName() {
    if (!this.user) {
      return;
    }
    if (this.user.isEmployee()) {
      let employee: Employee = store.getters["employees/GetEmployeeById"](this.user.employee_id);
      if (!employee) {
        await store.dispatch("employees/fetchEmployees", {
          includeHidden: false
        });
        employee = store.getters["employees/GetEmployeeById"](this.user.employee_id);
      }
      this.username = employee.display_name;
    } else {
      this.username = this.user.username;
    }
    this.shortname = this.user.shortname(this.username);
  }

  async changeInstitution(institution) {
    // Store the selected institution code in localStorage
    localStorage.setItem(
      this.LAST_SELECTED_INSTITUTION_KEY + this.user.id,
      institution.id.toString()
    );

    await store.dispatch("reset");

    await store.dispatch("security/selectInstitution", {
      institutionCode: institution.code,
      role: institution.role
    });
    await store.dispatch("security/getUser", true).then(async (user) => {
      this.user = user;
      if (!this.user || !this.user.selected_institution) {
        return;
      }
      const institutions: Institution[] = await store.dispatch("institutions/fetchInstitutions", {
        institutionId: user.selected_institution.id
      });

      store.commit("security/setInstitutions", institutions);
      store.commit("security/setSelectedInstitutionId", this.user.selected_institution.id);
      if (this.user.isManager()) {
        // SFOP-6844
        //this.showChangeRequestIcon = await this.anyChangeRequests();
      }
      this.setMenu();
      await store.dispatch("employments/fetchEmployments", {
        from: addYears(new Date(), -1),
        to: addYears(new Date(), 1)
      });
      await store.dispatch("employees/fetchEmployees", {
        includeHidden: false
      });
      this.setUserName();
      if (this.user && this.user.isEmployee()) {
        this.router.push({
          name: "pak",
          params: { employee_id: this.user.employee_id, date: format(new Date(), "yyyy-MM-dd") }
        });
      } else {
        if (window.location.pathname.indexOf("/module/dashboard") === -1) {
          this.router.push("/module/dashboard");
        } else {
          this.forceRender();
        }
      }
    });
  }

  forceRender() {
    this.componentKey += 1;
  }

  async goToLogout() {
    await store.dispatch("security/logout").then(() => {
      this.router.push("/");
    });
  }

  handlePasswordExpiration() {
    if (this.user && (this.user.password_last_changed === null || this.user.isEmployee())) {
      return;
    }

    // Password expires in 180 days, but must be warned 14 days before
    var passwordExpirationDays =
      180 - differenceInDays(new Date(), this.user?.password_last_changed as Date);
    if (passwordExpirationDays <= 14) {
      // Only prompt password update once per day
      if (localStorage.getItem("passwordExpirationNotification") !== new Date().toDateString()) {
        localStorage.setItem("passwordExpirationNotification", new Date().toDateString());
        var passwordExpirationText =
          i18n.global.t("passwordExpiration.passwordAboutToExpireBodyStart").toString() +
          passwordExpirationDays +
          i18n.global.t("passwordExpiration.passwordAboutToExpireBodyEnd").toString();
        setTimeout(() => {
          Dialog.create({
            title: i18n.global.t("passwordExpiration.passwordAboutToExpireTitle").toString(),
            message: passwordExpirationText,
            color: "primary",
            html: true,
            ok: i18n.global.t("changePassword.changePassword1"), // takes i18n value, or String for "OK" button label
            cancel: i18n.global.t("cancel") // takes i18n value, or String for "Cancel" button label
          }).onOk(() => {
            ShowChangePasswordDialog(this.user!);
          });
        }, 4000);
      }
    }
  }

  async visBrugerProfil() {
    if (!this.user) {
      return;
    }
    ShowUserProfileDialog(this.user).then((updatedUser) => {
      if (updatedUser) {
        store.getters["security/getUser"]() as User;
      }
    });
  }

  async visChangePassword() {
    ShowChangePasswordDialog(this.user!);
  }

  async visChangeToUnilogin() {
    const activation = await loginService.getActivations();
    ChangeToUniLoginDialog(activation);
  }

  visSupport() {
    this.router.push({ path: "/module/support" });
  }

  async anyFailedKmdRecords(recordType: "salary" | "absence") {
    if (this.user?.isEmployee()) {
      return false;
    }
    const salerySystem = this.user?.selected_institution?.salary_system;
    if (salerySystem !== eSalerySystem.KMD) {
      return false;
    }
    const salaryParam = {
      fromDate: subMonths(new Date(), 2),
      toDate: addMonths(endOfMonth(new Date()), 1)
    };

    const absenceParam = {
      from: subMonths(new Date(), 2),
      to: addMonths(endOfMonth(new Date()), 1),
      forceUpdate: true
    };

    const records = await store.dispatch(
      recordType === "salary" ? "salaries/fetchSalaryRecords" : "absences/fetchAbsences",
      recordType === "salary" ? salaryParam : absenceParam
    );
    const failedRecords = records.filter(
      (record: SalaryRecord | Absence) =>
        record.status === "FailedInApplication" || record.status === "FailedInLoensystem"
    );
    return failedRecords.length > 0;
  }

  async pendingAbsenceRequests(): Promise<number> {
    const absenceRequests = await store.dispatch("absenceRequests/fetchAbsenceRequests", {
      fromDate: subMonths(new Date(), 1),
      toDate: addMonths(new Date(), 2)
    });
    return absenceRequests.filter((request: AbsenceRequest) => request.state === "Pending").length;
  }

  async anyChangeRequests(): Promise<boolean> {
    if (this.user?.isEmployee()) {
      return false;
    }
    const wap: WebAcceptPages = await approveWorkHoursService.fetchApproveWorkHours(
      subMonths(startOfMonth(new Date()), 1),
      addMonths(endOfMonth(new Date()), 1)
    );
    const anyPending = wap.change_requests.some((cr) => cr.pending());
    return anyPending;
  }

  clearInterval() {
    if (this.intervalId !== null) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  startInterval() {
    if (this.intervalId !== null) {
      return; // Interval is already running
    }
    this.checkPendingChangeRequests();
    // SFOP-6844
    //this.checkPendingAbsenceRequests();
    this.intervalId = window.setInterval(() => {
      this.checkPendingChangeRequests();
      // SFOP-6844
      //this.checkPendingAbsenceRequests();
    }, 60000); // every minute
  }

  async checkPendingChangeRequests() {
    this.showChangeRequestIcon = await this.anyChangeRequests();
  }

  async checkPendingAbsenceRequests() {
    this.numberOfPendingAbsenceRequests = await this.pendingAbsenceRequests();
  }

  async setMenu() {
    this.menuEntries = [];
    let m: menutype, sm: menutype;
    m = {} as menutype;

    if (this.user && this.user.isManager()) {
      m.title = i18n.global.t("menu.Frontpage").toString();
      m.entryPointUrl = "/module/dashboard";
      m.iconName = "mdi-home";
      this.menuEntries.push(m);
    }
    if (this.user && this.user.isEmployee()) {
      m = {} as menutype;
      m.title = i18n.global.t("workhours").toString();
      m.entryPointUrl =
        "/module/actualplan/pak/" + this.user.employee_id + "/date/" + filters.date(new Date());
      m.iconName = "mdi-calendar-text";
      m.expand = false;
      this.menuEntries.push(m);
      m = {} as menutype;
      m.title = "Min side";
      m.entryPointUrl = "/module/employee/id/" + this.user.employee_id;
      m.iconName = "mdi-human-handsdown";
      m.expand = false;
      this.menuEntries.push(m);
    }
    m.expand = false;
    m = {} as menutype;
    m.title = i18n.global.t("menu.CurrentPlan").toString();
    m.entryPointUrl = "/module/actualplan";
    m.iconName = "mdi-timetable";
    m.expand = false;
    this.menuEntries.push(m);
    if (this.user && this.user.isManager()) {
      m = {} as menutype;
      m.title = i18n.global.t("planning.schedules").toString();
      m.entryPointUrl = "/module/planlaegning";
      m.iconName = "mdi-calendar";
      m.expand = false;
      this.menuEntries.push(m);
      m = {} as menutype;
      m.title = i18n.global.t("pools.pools").toString();
      m.entryPointUrl = "/module/pools";
      m.iconName = "mdi-timer-sand";
      m.expand = false;
      this.menuEntries.push(m);
      m = {} as menutype;
      m.title = i18n.global.t("menu.Staff").toString();
      m.entryPointUrl = "/module/employees";
      m.iconName = "mdi-human-handsdown";
      m.expand = false;
      m.menuEntries = [];
      sm = {} as menutype;
      sm.title = i18n.global.t("employments.renewEmployment").toString();
      sm.entryPointUrl = "/module/renewEmployment";
      sm.iconName = "";
      m.menuEntries.push(sm);
      sm = {} as menutype;
      sm.title = i18n.global.t("employees.webSettings").toString();
      sm.entryPointUrl = "/module/employees/employeeSettings";
      sm.iconName = "";
      m.menuEntries.push(sm);
      this.menuEntries.push(m);
      m = {} as menutype;
      m.title = i18n.global.t("absence.absence").toString();
      m.entryPointUrl = "/module/absence";
      m.iconName = "mdi-account-off";
      m.expand = false;
      m.showWarning = this.showAbsenceWarningIcon;
      this.menuEntries.push(m);
      m = {} as menutype;
      m.title = i18n.global.t("saleryAbsence.salary").toString();
      m.entryPointUrl = "/module/salary";
      m.iconName = "mdi-alarm";
      m.expand = false;
      m.showWarning = this.showSalaryWarningIcon;
      this.menuEntries.push(m);
      m = {} as menutype;
      m.title = i18n.global.t("menu.approveworkhours").toString();
      m.entryPointUrl = "/module/approveworkhours";
      m.iconName = "mdi-check-decagram";
      m.expand = false;
      m.showWarning = this.showChangeRequestIcon;
      this.menuEntries.push(m);
      m = {} as menutype;
      m.title = i18n.global.t("prints.prints").toString();
      m.entryPointUrl = "/module/prints";
      m.iconName = "mdi-printer";
      m.expand = false;
      this.menuEntries.push(m);
      m = {} as menutype;
      m.title = i18n.global.t("menu.reports").toString();
      m.entryPointUrl = "/module/report";
      m.iconName = "mdi-chart-pie";
      m.expand = false;
      this.menuEntries.push(m);

      m = {} as menutype;
      m.title = i18n.global.t("menu.Setup").toString();
      m.entryPointUrl = "/module/settings";
      m.iconName = "mdi-cog";
      m.expand = false;
      this.menuEntries.push(m);
    }
  }

  onReload(NewTitle: string) {
    this.title = NewTitle;
  }

  onUrlPath(NewUrlpath: string) {
    this.urlpath = (NewUrlpath + "#").substr(0, (NewUrlpath + "#").indexOf("#"));
  }

  async skiftsprog(sprog: string) {
    i18n.global.locale = sprog;
    this.setMenu();
  }
}
</script>

<style scoped>
.my-menu-link {
  font-weight: 700;
}

main {
  transition: margin-left 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94),
    width 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94);
}
</style>
<style lang="scss">
@import "../assets/variables";
#istmenutoggle[type="checkbox"]:checked ~ .hideOnMenuClosed,
#istmenutoggle[type="checkbox"]:checked ~ * .hideOnMenuClosed {
  display: none;
}

#istmenutoggle[type="checkbox"] {
  position: absolute;
  top: -9999px;
  left: -9999px;
}

#page_hotbar {
  display: none;
}
#menuusername {
  margin-left: 8px;
  text-transform: none;
}
@media screen and (min-width: 1030px) {
  #istmenutoggle[type="checkbox"]:checked ~ * aside,
  #istmenutoggle[type="checkbox"]:checked ~ aside {
    width: 60px;
  }
  #istmenutoggle[type="checkbox"]:checked ~ * main,
  #istmenutoggle[type="checkbox"]:checked ~ main {
    width: calc(100vw - 65px);
    margin-left: 60px;
  }
  #istmenutoggle[type="checkbox"]:checked ~ * aside .ist-list .ist-menu-label {
    left: -400px;
    position: absolute;
    transition: left 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94),
      width 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94);
  }

  #istmenutoggle ~ * aside .ist-list .warningIcon {
    top: 0px;
    right: 0;
  }

  #istmenutoggle[type="checkbox"]:checked ~ * aside .ist-list .warningIcon {
    margin-left: -10px;
    top: -10px;
  }
}

@media screen and (min-width: 600px) and (max-width: 1029px) {
  aside.ist-leftmenu {
    width: 60px !important ;
  }
  #istEveryday {
    display: none;
  }

  main {
    width: calc(100vw - 65px) !important;
    margin-left: 65px !important;
  }
  main .ist-contents {
    margin: 0px !important;
  }

  aside .ist-list .ist-menu-label {
    left: -400px !important;
    position: absolute;
    transition: left 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94),
      width 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94);
  }

  #istEveryday {
    display: none;
  }

  #istmenutoggle[type="checkbox"]:checked ~ * aside.ist-leftmenu,
  #istmenutoggle[type="checkbox"]:checked ~ aside.ist-leftmenu {
    width: 260px !important;
    z-index: 5000 !important ;
  }

  #istmenutoggle[type="checkbox"]:checked ~ * header .ist-header-toolbar,
  #istmenutoggle[type="checkbox"]:checked ~ header .ist-header-toolbar {
    opacity: 0;
    transition: opacity 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94);
  }

  #istmenutoggle[type="checkbox"]:checked ~ * header .ist-header-section,
  #istmenutoggle[type="checkbox"]:checked ~ header .ist-header-section {
    margin-left: 200px !important;
    transition: margin-left 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94);
  }
  #istmenutoggle[type="checkbox"]:checked ~ * aside .ist-list .ist-menu-label,
  #istmenutoggle[type="checkbox"]:checked ~ aside .ist-list .ist-menu-label {
    left: auto !important;
    position: relative;
    transition: left 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94),
      width 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94);
  }

  #istmenutoggle ~ * aside .ist-list .warningIcon {
    position: absolute;
    top: 2px;
    right: 0;
  }

  #istmenutoggle[type="checkbox"]:checked ~ * aside .ist-list .warningIcon {
    position: relative;
    top: 0px;
  }
}

@media screen and (max-width: 599px) {
  #page_hotbar {
    width: 100%;
    position: fixed;
    bottom: 0px;
    top: auto;
    z-index: 5000;
    background-color: $ist-blue;
    display: block;
    color: white;
  }
  #menuusername,
  #institutionsNavnDropdown {
    display: none;
  }

  main {
    width: 100vw !important;
    margin-left: 0px !important;
  }
  main .ist-contents {
    margin: 0px !important;
  }
  aside.ist-leftmenu {
    flex: 0 0 0 !important;
    width: 100% !important;
    z-index: 10000;
    height: 0;
    opacity: 0;
    top: 100vh !important;
  }

  .ist-main header,
  main header {
    padding: 0 8px !important;
  }

  aside .ist-list .ist-menu-label {
    left: 65px !important;
    white-space: nowrap;
  }
  #istmenutoggle[type="checkbox"]:checked ~ aside.ist-leftmenu {
    flex: 0 0 100% !important;
    width: 100% !important;
  }

  #istmenutoggle[type="checkbox"]:checked ~ * aside .ist-list .warningIcon {
    margin-left: -10px;
  }
}

header .ist-header-section button {
  padding: 0 0 0 0;
  margin: 0;
}

header .ist-header-section button .on-left {
  margin-right: 4px;
  margin-left: 16px;
}

.ist-header-toolbar--item {
  align-items: center;
  border: none;
  display: inline-flex;
  justify-content: center;
  outline: none;
  position: relative;
  z-index: 0;
  -webkit-font-smoothing: antialiased;
  letter-spacing: 0.25px;
  background: none;
  border-radius: 4px;
  color: #5f6368;
  cursor: pointer;
  -webkit-font-smoothing: auto;
  font-size: 0.75rem;
  letter-spacing: 0.3px;
  font-weight: normal;
  margin: 0 -8px 0 0;
  padding: 0 8px;
  height: 64px;
  line-height: 64px;

  & .q-focus-helper {
    background-color: transparent !important;
  }
}

.ist-header-toolbar--item:hover::before {
  transform: scale(1);
  opacity: 0.12;
}

.ist-header-toolbar--item::before {
  content: "";
  display: block;
  opacity: 0;
  position: absolute;
  transition-duration: 0.15s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  z-index: -1;
  bottom: 0;
  left: 8px;
  right: -8px;
  top: -1px;
  background: #202124;
  border-radius: 4px;
  transform: scale(0);
  margin: 0;
  padding: 14px;
  transition-property: transform, opacity;
}
.ist-list-footer {
  position: fixed;
  bottom: 0px;
  text-align: center;
  width: 100%;
}

@media screen and (min-height: 0px) and (max-height: 700px) {
  .ist-list-footer {
    display: none;
  }
}

#nyheder {
  background-color: #efefef;
  color: #000;
  min-height: 60px;
  padding: 8px;
  line-height: 28px;
  font-family: "Libre Franklin", sans-serif;
  font-size: 24px;
}

header .ist-header-section-start {
  min-height: 65px !important;
  display: grid !important;
}

.warningIcon {
  padding-right: 5px;
  padding-bottom: 3px;
  color: #ffc107;
  font-size: 20px;
}

.clickable {
  cursor: pointer;
}

.q-btn:before {
  box-shadow: none !important;
}

.q-item__section {
  white-space: nowrap;
}

@media print {
  * {
    margin: 0 !important;
    padding: 0 !important;
  }
  html,
  body {
    height: 100%;
    overflow: hidden;
    color: #000;
    background-color: #fff;
    -webkit-print-color-adjust: exact !important;
  }
  header,
  footer,
  aside,
  nav,
  form,
  iframe,
  .menu,
  .hero,
  .adslot {
    display: none;
  }
  #page_navigation {
    display: none;
  }
  .ist-main,
  main {
    width: 100vw !important;
    margin-left: 0px !important;
    @media print {
      background: #fff;
    }
  }
  .ist-contents {
    margin: 0 !important;
  }

  .noprint {
    visibility: hidden;
    display: none;
  }
}

.ist-contents--overlay {
  width: 100%;
  min-height: 100%;
  position: absolute;
  z-index: 4500;
  top: 0;
  left: 0;
  background-color: #0002;
}

.sticky-header tr:first-child th {
  position: sticky;
  z-index: 1;
  background-color: white;
  top: 0;
}

@media screen and (max-width: 800px) {
  .desktop-only {
    display: none;
  }
}

.divFloatLeftRight div:nth-child(1) {
  float: left;
}
.divFloatLeftRight div:nth-child(2) {
  float: right;
}

.q-card > div > ol {
  padding-left: 20px;
}

.q-card > div > ul {
  padding-left: 20px;
}

.q-card > div > div > ol {
  padding-left: 20px;
}

.q-card > div > div > ul {
  padding-left: 20px;
}

.sticky-header-table {
  /* height or max-height is important */
  height: calc(100vh - 270px);
}

.sticky-header-table tr:first-child th {
  position: sticky;
  z-index: 10;
  background-color: white;
  top: 0;
}

.conflict-icon {
  margin-top: 10px;
  margin-right: 5px;
}

.eye-off {
  display: inline-block;
  width: 20px;
  height: 15px;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 24 24'%3E%3Cpath fill='%23000' d='M11.83 9L15 12.16V12a3 3 0 0 0-3-3zm-4.3.8l1.55 1.55c-.05.21-.08.42-.08.65a3 3 0 0 0 3 3c.22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53a5 5 0 0 1-5-5c0-.79.2-1.53.53-2.2M2 4.27l2.28 2.28l.45.45C3.08 8.3 1.78 10 1 12c1.73 4.39 6 7.5 11 7.5c1.55 0 3.03-.3 4.38-.84l.43.42L19.73 22L21 20.73L3.27 3M12 7a5 5 0 0 1 5 5c0 .64-.13 1.26-.36 1.82l2.93 2.93c1.5-1.25 2.7-2.89 3.43-4.75c-1.73-4.39-6-7.5-11-7.5c-1.4 0-2.74.25-4 .7l2.17 2.15C10.74 7.13 11.35 7 12 7'/%3E%3C/svg%3E");
}

.multiple_messages {
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 10px;
}
</style>
